
















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";

const CostBearerDocumentModule = namespace("cost-bearer-document");

@Component({
  components: { AbortButton, FscSimpleCard, SaveButton },
})
export default class CostBearerBookingInvoicePreview extends Vue {
  public name = "CostBearerBookingInvoicePreview";

  @CostBearerDocumentModule.Action("costBearerPaymentInvoicePreview")
  public generateInvoicePreview: any;

  @CostBearerDocumentModule.Getter("getMimeType")
  public mimeType: any;

  @CostBearerDocumentModule.Getter("getDataItem")
  public blob: any;

  @CostBearerDocumentModule.Getter("getIsLoading")
  public isLoading: any;

  @Prop()
  public costBearerId!: any;

  @Prop()
  public invoiceData!: any;

  private source = "";

  public mounted(): void {
    if (this.costBearerId) {
      const data = {
        costBearerId: this.costBearerId,
        costBearerCustomBookingIds: this.invoiceData,
      };
      this.generateInvoicePreview(data);
    }
  }

  @Watch("blob")
  public onStudentDocumentChange(blob: any) {
    if (blob) {
      this.source =
        "data:" +
        this.mimeType +
        ";base64," +
        //@ts-ignore
        new Buffer(blob, "binary").toString("base64");
    }
  }

  protected ok(): void {
    this.$emit("ok");
  }

  protected cancel(): void {
    this.$emit("cancel");
  }
}
